/**
 * BD1 — shared session hydration for every login origin.
 *
 * OtpScreen, the Google-OAuth return handler (LoginRoute), and the new
 * password endpoints all mint the same {token, user} shape. This helper is
 * the single place that writes it to storage, keeping React (bsure_token)
 * and the legacy form.html (ig_t / ig_u) byte-symmetric — the same ritual
 * OtpScreen and consumeGoogleOAuthReturn already perform inline.
 */

export interface AuthUser {
  id: string;
  email?: string;
  name?: string;
  is_new?: boolean;
  onboarding_done?: boolean;
  credit_balance?: number;
}

export function hydrateSession(data: { token: string; user: AuthUser }): void {
  window.localStorage.setItem("bsure_token", data.token);
  window.localStorage.setItem("ig_t", data.token);
  window.localStorage.setItem("ig_u", JSON.stringify(data.user));
  if (data.user.email) {
    window.localStorage.setItem("bsure_email", data.user.email);
  }
}

export function getSessionToken(): string {
  return window.localStorage.getItem("bsure_token") || "";
}
